/**
 * Gets the fine tuning solution from the config data using the solution name
 *
 * @param fineTuningConfigData Fine tuning config data
 * @param solutionName Input solution name
 * @returns Returns the fine tuning solution from the config data using the solution name
 */
export function getSolutionIdFromName(fineTuningConfigData, solutionName) {
    var solutions = fineTuningConfigData.Solution;
    var selectedSolution = solutions.find(function (solution) { return solution.Name == solutionName; });
    return selectedSolution === null || selectedSolution === void 0 ? void 0 : selectedSolution.Id;
}
/**
 * Checks if a fine tuning solution is valid or not
 *
 * @param offset Input offset
 * @param currentMasterGain Current mastergain
 * @param currentFourBandEqualizer Current 4BE
 * @param minMasterGain Minimum mastergain
 * @param maxMasterGain Maximum mastergain
 * @returns Returns true if the solution is valid
 */
export function isSolutionValid(offset, currentMasterGain, currentFourBandEqualizer, minMasterGain, maxMasterGain) {
    var min4BE = -12;
    var max4BE = 9;
    var newMasterGain = currentMasterGain + offset.MasterGain;
    var newBand1 = currentFourBandEqualizer.Band1 + offset.Band1;
    var newBand2 = currentFourBandEqualizer.Band2 + offset.Band2;
    var newBand3 = currentFourBandEqualizer.Band3 + offset.Band3;
    var newBand4 = currentFourBandEqualizer.Band4 + offset.Band4;
    var invalidMG = newMasterGain < minMasterGain || newMasterGain > maxMasterGain;
    var invalidBand1 = newBand1 < min4BE || newBand1 > max4BE;
    var invalidBand2 = newBand2 < min4BE || newBand2 > max4BE;
    var invalidBand3 = newBand3 < min4BE || newBand3 > max4BE;
    var invalidBand4 = newBand4 < min4BE || newBand4 > max4BE;
    return !(invalidMG ||
        invalidBand1 ||
        invalidBand2 ||
        invalidBand3 ||
        invalidBand4);
}
